import { useEffect, useRef, useState } from "react";
import Table from "../../atom/table";
import FadeIn from "react-fade-in";
import {
  BargeIcon,
  EarIcon,
  EyeIcon,
  TableSortIconDownArrow,
} from "../../utils/icons/defaultIcons";
import TableTopBar from "../modal/tableTopBar";
import { useDispatch, useSelector } from "react-redux";
import { activeCallRecording } from "../../toolkit/reducers/callRecordingsSlice";
import { enableActionState, getToken } from "../../services/api";
import NoResultsFound from "../../atom/noResultsFound";
import { getENVData } from "../../config/environment";
import Notification from "../../atom/Notification";
import * as loaderLottie from "../../utils/lottie/loaderLottie.json";
import { Backdrop } from "@mui/material";
import Lottiefy from "../../atom/lottie/lottie";

function CallsInProgress() {
  const isComponentMounted = useRef(true); // To track if the component is mounted
  const [resultNotFound, setResultNotFound] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);

  const [tableTitles, setTableTitles] = useState<any>([
    {
      key: "direction",
      title: "Direction",
      icon: <TableSortIconDownArrow />,
      tooltip: "Indicates whether the call is incoming, outgoing or internal.",
      sort: { direction: "asc", active: false },
      hide: {
        status: true,
        default: false,
      },
    },
    {
      key: "extension",
      title: "Extension",
      icon: <TableSortIconDownArrow />,
      tooltip: "The internal phone extension handling this call.",
      sort: { direction: "asc", active: false },
      hide: {
        status: true,
        default: false,
      },
    },
    {
      key: "extension_name",
      title: "Extension Name",
      icon: <TableSortIconDownArrow />,
      tooltip: "Name of the internal phone extension handling this call.",
      sort: { direction: "asc", active: false },
      hide: {
        status: true,
        default: false,
      },
    },

    {
      key: "from_number",
      title: "Call Origination",
      icon: <TableSortIconDownArrow />,
      tooltip: "The phone number or extension where the call started.",
      sort: { direction: "asc", active: false },
      hide: {
        status: true,
        default: true,
      },
    },
    {
      key: "to_number",
      title: "Call Destination",
      icon: <TableSortIconDownArrow />,
      tooltip: "The phone number or extension the call is connected to.",
      sort: { direction: "asc", active: false },
      hide: {
        status: true,
        default: true,
      },
    },
    {
      key: "answer_time",
      title: "Start Time",
      tooltip: "The exact time this call began.",
      sort: { direction: "asc", active: false },
      type: "time",
      hide: {
        status: true,
        default: false,
      },
    },
    {
      key: "duration",
      title: "Duration",
      type: "duration",
      tooltip: "The total time this call has been active.",
      sort: { direction: "asc", active: false },
      hide: {
        status: true,
        default: false,
      },
    },
    {
      key: "state",
      title: "Call State",
      tooltip:
        "The current status of the call, such as ringing, connected, or on hold.",
      sort: { direction: "asc", active: false },
      hide: {
        status: true,
        default: false,
      },
    },
    // {
    //   key: "action_button",
    //   title: "",
    //   type: "actionIcon",
    //   class: "",
    //   iconDisable: false,
    //   isActive: false,
    //   icon: <EyeIcon />,
    //   alwaysVisible: true,
    //   action: {
    //     title: "Monitor",
    //     command: "monitor",
    //     action: "click",
    //     tooltip: "Listen",
    //   },
    // },
    // {
    //   key: "action_button",
    //   title: "",
    //   type: "actionIcon",
    //   class: "",
    //   icon: <EarIcon />,
    //   iconDisable: false,
    //   isActive: false,
    //   alwaysVisible: true,
    //   action: {
    //     title: "Coach",
    //     command: "coach",
    //     action: "click",
    //     tooltip: "Coach",
    //   },
    // },
    // {
    //   key: "action_button",
    //   title: "",
    //   type: "actionIcon",
    //   class: "-mb-1 ",
    //   icon: <BargeIcon />,
    //   iconDisable: false,
    //   isActive: false,
    //   alwaysVisible: true,
    //   action: {
    //     title: "Barge",
    //     command: "barge",
    //     action: "click",
    //     tooltip: "Barge",
    //   },
    // },
  ]);

  // const icons = [EyeIcon, EarIcon, BargeIcon]
  const icons = [
    <svg
      width="20"
      height="15"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.389 5.77219C17.3644 5.71664 16.7688 4.39547 15.4448 3.07148C13.6807 1.30734 11.4525 0.375 8.99999 0.375C6.54749 0.375 4.31929 1.30734 2.55515 3.07148C1.23117 4.39547 0.632806 5.71875 0.611009 5.77219C0.579026 5.84413 0.5625 5.92198 0.5625 6.0007C0.5625 6.07943 0.579026 6.15728 0.611009 6.22922C0.635618 6.28477 1.23117 7.60523 2.55515 8.92922C4.31929 10.6927 6.54749 11.625 8.99999 11.625C11.4525 11.625 13.6807 10.6927 15.4448 8.92922C16.7688 7.60523 17.3644 6.28477 17.389 6.22922C17.421 6.15728 17.4375 6.07943 17.4375 6.0007C17.4375 5.92198 17.421 5.84413 17.389 5.77219ZM8.99999 10.5C6.83578 10.5 4.94507 9.7132 3.37992 8.16211C2.73771 7.52346 2.19134 6.7952 1.75781 6C2.19123 5.20472 2.73761 4.47645 3.37992 3.83789C4.94507 2.2868 6.83578 1.5 8.99999 1.5C11.1642 1.5 13.0549 2.2868 14.6201 3.83789C15.2635 4.4763 15.8111 5.20457 16.2457 6C15.7387 6.94641 13.5302 10.5 8.99999 10.5ZM8.99999 2.625C8.33248 2.625 7.67996 2.82294 7.12494 3.19379C6.56993 3.56464 6.13735 4.09174 5.8819 4.70844C5.62645 5.32514 5.55962 6.00374 5.68984 6.65843C5.82007 7.31312 6.14151 7.91448 6.61351 8.38649C7.08551 8.85849 7.68688 9.17993 8.34156 9.31015C8.99625 9.44038 9.67485 9.37354 10.2916 9.11809C10.9083 8.86265 11.4354 8.43007 11.8062 7.87505C12.1771 7.32003 12.375 6.66751 12.375 6C12.3741 5.10518 12.0182 4.24728 11.3855 3.61454C10.7527 2.98181 9.89481 2.62593 8.99999 2.625ZM8.99999 8.25C8.55499 8.25 8.11997 8.11804 7.74996 7.87081C7.37995 7.62357 7.09156 7.27217 6.92127 6.86104C6.75097 6.4499 6.70641 5.9975 6.79323 5.56105C6.88004 5.12459 7.09434 4.72368 7.409 4.40901C7.72367 4.09434 8.12458 3.88005 8.56104 3.79323C8.9975 3.70642 9.4499 3.75097 9.86103 3.92127C10.2722 4.09157 10.6236 4.37996 10.8708 4.74997C11.118 5.11998 11.25 5.55499 11.25 6C11.25 6.59674 11.0129 7.16903 10.591 7.59099C10.169 8.01295 9.59673 8.25 8.99999 8.25Z"
        fill="#333333"
      />
    </svg>,
    <svg
      width="20"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1875 6.3125C13.1875 6.46168 13.1282 6.60476 13.0227 6.71025C12.9173 6.81574 12.7742 6.875 12.625 6.875C12.4758 6.875 12.3327 6.81574 12.2273 6.71025C12.1218 6.60476 12.0625 6.46168 12.0625 6.3125C12.0625 4.96984 11.5291 3.68217 10.5797 2.73277C9.63032 1.78337 8.34266 1.25 7 1.25C5.65734 1.25 4.36967 1.78337 3.42027 2.73277C2.47087 3.68217 1.9375 4.96984 1.9375 6.3125C1.9375 8.18984 2.53727 8.76781 3.17289 9.38094C3.78039 9.96875 4.46875 10.6304 4.46875 12.2188C4.46875 12.8901 4.73543 13.5339 5.21014 14.0086C5.68484 14.4833 6.32867 14.75 7 14.75C7.72 14.75 8.29727 14.4575 8.81617 13.8296C8.86265 13.771 8.92033 13.7223 8.98586 13.6863C9.05138 13.6503 9.12342 13.6277 9.19777 13.6199C9.27213 13.612 9.3473 13.6191 9.41889 13.6406C9.49049 13.6622 9.55707 13.6978 9.61474 13.7454C9.67241 13.7929 9.72002 13.8515 9.75479 13.9177C9.78955 13.9839 9.81077 14.0564 9.8172 14.1309C9.82363 14.2054 9.81515 14.2804 9.79225 14.3516C9.76935 14.4227 9.73249 14.4886 9.68383 14.5454C8.95539 15.4278 8.05469 15.875 7 15.875C6.03064 15.8739 5.10131 15.4883 4.41587 14.8029C3.73044 14.1174 3.34487 13.1881 3.34375 12.2188C3.34375 11.1085 2.94438 10.7232 2.39172 10.1909C1.68859 9.51172 0.8125 8.66797 0.8125 6.3125C0.8125 4.67147 1.4644 3.09766 2.62478 1.93728C3.78516 0.776896 5.35897 0.125 7 0.125C8.64103 0.125 10.2148 0.776896 11.3752 1.93728C12.5356 3.09766 13.1875 4.67147 13.1875 6.3125ZM10.5065 10.3259C10.4425 10.2888 10.3719 10.2647 10.2986 10.255C10.2253 10.2452 10.1507 10.25 10.0793 10.2691C10.0079 10.2882 9.94087 10.3211 9.88218 10.3661C9.82349 10.4111 9.77425 10.4672 9.73726 10.5312C9.67538 10.6385 9.57981 10.7224 9.46538 10.7698C9.35096 10.8173 9.22408 10.8256 9.10443 10.7936C8.98478 10.7615 8.87906 10.6909 8.80368 10.5926C8.72829 10.4943 8.68745 10.3739 8.6875 10.25C8.6875 9.59398 9.02641 9.14188 9.41875 8.61875C9.86664 8.02109 10.375 7.34398 10.375 6.3125C10.375 5.41739 10.0194 4.55895 9.38649 3.92601C8.75355 3.29308 7.89511 2.9375 7 2.9375C6.10489 2.9375 5.24645 3.29308 4.61351 3.92601C3.98058 4.55895 3.625 5.41739 3.625 6.3125C3.625 6.46168 3.68426 6.60476 3.78975 6.71025C3.89524 6.81574 4.03832 6.875 4.1875 6.875C4.33668 6.875 4.47976 6.81574 4.58525 6.71025C4.69074 6.60476 4.75 6.46168 4.75 6.3125C4.75 5.71576 4.98705 5.14347 5.40901 4.72151C5.83097 4.29955 6.40326 4.0625 7 4.0625C7.59674 4.0625 8.16903 4.29955 8.59099 4.72151C9.01295 5.14347 9.25 5.71576 9.25 6.3125C9.25 6.96852 8.91109 7.42062 8.51875 7.94375C8.07086 8.54141 7.5625 9.21852 7.5625 10.25C7.56262 10.6214 7.68525 10.9823 7.91137 11.2769C8.1375 11.5715 8.45448 11.7833 8.8132 11.8794C9.17192 11.9756 9.55233 11.9507 9.89546 11.8086C10.2386 11.6666 10.5253 11.4153 10.7111 11.0938C10.7856 10.9648 10.8059 10.8115 10.7676 10.6675C10.7292 10.5236 10.6353 10.4007 10.5065 10.3259Z"
        fill="#333333"
      />
    </svg>,
    <svg
      width="20"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.96047 7.39797L6.14797 10.2105C6.09571 10.2627 6.03366 10.3042 5.96538 10.3325C5.8971 10.3608 5.82391 10.3753 5.75 10.3753C5.67609 10.3753 5.6029 10.3608 5.53462 10.3325C5.46634 10.3042 5.40429 10.2627 5.35203 10.2105C5.29977 10.1582 5.25831 10.0962 5.23003 10.0279C5.20174 9.9596 5.18719 9.88641 5.18719 9.8125C5.18719 9.73859 5.20174 9.6654 5.23003 9.59712C5.25831 9.52884 5.29977 9.46679 5.35203 9.41453L7.20477 7.5625H0.6875C0.538316 7.5625 0.395242 7.50324 0.289752 7.39775C0.184263 7.29226 0.125 7.14918 0.125 7C0.125 6.85082 0.184263 6.70774 0.289752 6.60225C0.395242 6.49676 0.538316 6.4375 0.6875 6.4375H7.20477L5.35203 4.58547C5.24648 4.47992 5.18719 4.33677 5.18719 4.1875C5.18719 4.03823 5.24648 3.89508 5.35203 3.78953C5.45758 3.68398 5.60073 3.62469 5.75 3.62469C5.89927 3.62469 6.04242 3.68398 6.14797 3.78953L8.96047 6.60203C9.01277 6.65427 9.05426 6.71631 9.08257 6.7846C9.11087 6.85288 9.12544 6.92608 9.12544 7C9.12544 7.07392 9.11087 7.14712 9.08257 7.2154C9.05426 7.28369 9.01277 7.34573 8.96047 7.39797ZM12.5 0.25H8.5625C8.41332 0.25 8.27024 0.309263 8.16475 0.414753C8.05926 0.520242 8 0.663316 8 0.8125C8 0.961684 8.05926 1.10476 8.16475 1.21025C8.27024 1.31574 8.41332 1.375 8.5625 1.375H12.5V12.625H8.5625C8.41332 12.625 8.27024 12.6843 8.16475 12.7898C8.05926 12.8952 8 13.0383 8 13.1875C8 13.3367 8.05926 13.4798 8.16475 13.5852C8.27024 13.6907 8.41332 13.75 8.5625 13.75H12.5C12.7984 13.75 13.0845 13.6315 13.2955 13.4205C13.5065 13.2095 13.625 12.9234 13.625 12.625V1.375C13.625 1.07663 13.5065 0.790483 13.2955 0.579505C13.0845 0.368526 12.7984 0.25 12.5 0.25Z"
        fill="#98A6DD"
      />
    </svg>,
  ];

  const dispatch = useDispatch();
  const value = useSelector((state: any) => state.Call.callName);
  const activeMenu = useSelector((state: any) => state.menuItem.value);
  const [eventsData, setEventsData] = useState<any>([]);
  const [previewData, setPreviewData] = useState<any>([]);

  const [searchtext, setSearchText] = useState<any>("");

  const change = (activeData: number) => {
    dispatch(activeCallRecording(activeData));
  };

  const socketRef = useRef<WebSocket | null>(null);

  const accessToken = useSelector((state: any) => state.auth.token);
  const isFirstRender = useRef(true);
  const iconTypes = ["monitor", "coach", "barge"];
  const handleNonRecordingCalls = () => {
    setTableTitles((prevTableTitles: any[]) =>
      prevTableTitles.map((node: any) => {
        if (node.type === "actionIcon") {
          return { ...node, iconDisable: true };
        }
        return node;
      })
    );
  };
  //test
  const handleRecordableCalls = (events: any) => {
    setTableTitles((prevTableTitles: any[]) =>
      prevTableTitles.map((node: any) => {
        if (node.type === "actionIcon") {
          return { ...node, iconDisable: false };
        }
        return node;
      })
    );

    console.log("recordevents", events);
    if (iconTypes.includes(events?.monitor_state)) {
      console.log("monitor_state1", events?.monitor_state);
      setTableTitles((prevTableTitles: any[]) =>
        prevTableTitles.map((node: any) => {
          if (node?.action?.command === events?.monitor_state) {
            return { ...node, isActive: true };
          }
          return { ...node, isActive: false };
        })
      );
    } else {
      console.log("monitor_state2", events?.monitor_state);
      setTableTitles((prevTableTitles: any[]) =>
        prevTableTitles.map((node: any) => {
          return node;
        })
      );
    }
  };

  const handleIcons = (data: any) => {
    if (!data?.is_crs_call) {
      handleNonRecordingCalls();
    } else {
      handleRecordableCalls(data);
    }
  };

  const handleTableTitle = (data: any) => {
    setTableTitles([...data]);
    var status: any = {};
    data
      .filter((node: any) => node?.hide?.status !== undefined)
      .map((node: any) => {
        status[node.key] = node.hide.status;
      });
    window.sessionStorage.setItem("callsinprogress", JSON.stringify(status));
  };

  const handleIconClick = (action: string, data: any) => {
    console.log("action", action, "data", data);
    let payload = {
      action: action,
    };
    enableActionState(data?.smdr_call_id, action, payload).then(
      (result: any) => {
        if (!result?.success) {
          let msg = result?.message;
          Notification(
            "Failed",
            msg?.charAt(0).toUpperCase() + msg.slice(1),
            "danger"
          );
        }
      }
    );
  };

  const actionHandler = (action: string, data: any, index: number) => {
    console.log("action", action, "data", data);
    const actionsMap: any = {
      monitor: handleIconClick,
      coach: handleIconClick,
      barge: handleIconClick,
    };
    const act = actionsMap[action];
    if (act) {
      act(action, data);
    } else {
      console.log("actionHandler Error");
    }
  };

  const formatNumbers = (number: any) => {
    const prefixCases = ["911", "811", "1", "011"];
    if (number.length >= 10) {
      // debugger;
      for (let prefix of prefixCases) {
        if (number.startsWith(prefix)) {
          number = number.slice(prefix.length);
          break;
        }
      }
      var formattedPhoneNumber = "";
      if (number.length === 12) {
        const areaCode = number.slice(2, 5);
        const firstThree = number.slice(5, 9);
        const lastFour = number.slice(9, 12);
        formattedPhoneNumber = `+${number.slice(
          0,
          2
        )} (${areaCode}) ${firstThree}-${lastFour}`;
      } else if (number.length === 11) {
        const areaCode = number.slice(1, 4);
        const firstThree = number.slice(4, 8);
        const lastFour = number.slice(8, 11);
        formattedPhoneNumber = `${number.slice(
          0,
          1
        )} (${areaCode}) ${firstThree}-${lastFour}`;
      } else {
        const areaCode = number.slice(0, 3);
        const firstThree = number.slice(3, 6);
        const lastFour = number.slice(6, 10);
        formattedPhoneNumber = `(${areaCode}) ${firstThree}-${lastFour}`;
      }

      return formattedPhoneNumber;
    } else {
      return number;
    }
  };

  const connectWebSocket = () => {
    if (!isComponentMounted.current) return;
    //test 8

    const wssUrl = getENVData().baseURL.replace("https", "wss");
    if (!socketRef.current) {
      socketRef.current = new WebSocket(
        `${wssUrl}events/liveboard/tenants/${getToken()}/ws/calls_in_progress?token=${accessToken}`
      );
      setLoader(true);

      socketRef.current.addEventListener("open", (event) => {
        console.log("Connected to WebSocket", event);
        setResultNotFound(true);
        setLoader(false);
      });
      socketRef.current.addEventListener("message", (event) => {
        console.log("Message received from server:", event.data);
        setResultNotFound(false);
        setLoader(false);

        const data = JSON.parse(event.data);

        Object.keys(data).forEach((node: any) => {
          if (node === "is_crs_call") {
            data["disabled"] = !data[node];
            console.log(data[node], "is_crs_call");
            if (!data[node]) {
              data["hidden"] = true;
            } else {
              data["hidden"] = false;
            }
          }
          if (node === "direction") {
            data["direction"] =
              data["direction"].charAt(0).toUpperCase() +
              data["direction"].slice(1);
          }
          if (node === "from_number") {
            data["from_number"] = formatNumbers(data[node]);
          }
          if (node === "to_number") {
            data["to_number"] = formatNumbers(data[node]);
          }

          // if (node === "is_crs_call") {
          //   data["disabled"] = !data[node];
          // }
        });

        // console.log("Message received from server:", event.data);
        setResultNotFound(false);

        if (data?.event === "call.create") {
          setResultNotFound(false);
          setEventsData((prevEvents: any) => [...prevEvents, data]);
          handleIcons(data);
        }
        if (data?.event === "call.update") {
          setResultNotFound(false);
          setEventsData((prevEvents: any) =>
            prevEvents.map((event: any) =>
              event.call_id === data.call_id ? { ...event, ...data } : event
            )
          );
          handleIcons(data);
        }
        if (data?.event === "call.delete") {
          setResultNotFound(false);
          setEventsData((prevEvents: any) =>
            prevEvents.filter((event: any) => event.call_id !== data.call_id)
          );
        }
      });

      socketRef.current.addEventListener("close", (e) => {
        setLoader(false);
        if (isComponentMounted.current) {
          console.log("WebSocket connection closed", socketRef.current, e);
          console.log("WebSocket connection closed Attempting to reconnect...");
          socketRef.current = null;
          reconnectWebSocket();
        } else {
          console.log(
            "WebSocket closed and no reconnect as component is unmounted."
          );
        }
        // }
      });
      socketRef.current.addEventListener("error", (error) => {
        setLoader(false);
        console.error("WebSocket encountered an error:", error);
        if (socketRef.current) {
          socketRef.current.close(1000, "Normal closure"); // Close the connection on error
        }
      });
    }
  };
  const sortArrayByKey = (array: any, key: any, order = "asc") => {
    return array.sort((a: any, b: any) => {
      if (a[key] < b[key]) return order === "asc" ? -1 : 1;
      if (a[key] > b[key]) return order === "asc" ? 1 : -1;
      return 0; // If equal
    });
  };
  const generateRandomColor = () => {
    const randomComponent = () =>
      Math.floor(200 + Math.random() * 55)
        .toString(16)
        .padStart(2, "0"); // Restrict to 200-255
    return `#${randomComponent()}${randomComponent()}${randomComponent()}`;
  };
  let groupValue;
  const groupedData = useRef<any>({});
  const groupBy = (array: any, key: any) => {
    return array.reduce((result: any, currentItem: any) => {
      // Get the value of the key for grouping
      groupValue = currentItem[key];
      // Create a new group if it doesn't exist
      if (!result[groupValue + "_length"]) {
        result[groupValue + "_length"] = 1;
        // Check if the color already exists, if not generate a new one
        if (!result[groupValue] && !groupedData.current[groupValue]) {
          result[groupValue] = generateRandomColor();
        } else {
          result[groupValue] = groupedData.current[groupValue];
        }
      } else {
        result[groupValue + "_length"] += 1;
      }
      // Add the current item to the group
      return result;
    }, {});
  };
  const reconnectWebSocket = () => {
    if (!isComponentMounted.current) return; // Stop reconnecting if the component is unmounted
    setTimeout(() => {
      console.log("Reconnecting WebSocket...");
      setEventsData([]); // Clear existing data before reconnecting
      connectWebSocket(); // Retry connection
    }, 3000); // Retry after 3 seconds
  };
  useEffect(() => {
    groupedData.current = groupBy(eventsData, "smdr_call_id");
    const data = [...eventsData];
    data.map((node: any) => {
      if (node?.smdr_call_id) {
        node["color"] =
          groupedData.current[node?.smdr_call_id] &&
          groupedData.current[node?.smdr_call_id + "_length"] > 1
            ? groupedData.current[node?.smdr_call_id]
            : undefined;
      }
    });
    setPreviewData(sortArrayByKey(data, "smdr_call_id"));
  }, [eventsData]);

  useEffect(() => {
    isComponentMounted.current = true; // Component is mounted
    if (socketRef.current) {
      socketRef.current.close(1000, "Normal closure");
      console.log("WebSocket closed during cleanup");
    }
    setTimeout(connectWebSocket, 100);
    // Cleanup WebSocket when the component unmounts
    return () => {
      isComponentMounted.current = false; // Component is unmounted
      if (socketRef.current) {
        socketRef.current.close(1000, "Normal closure");
        console.log("WebSocket closed during cleanup");
      }
      console.log("socketRef", socketRef);
    };
  }, []);

  return (
    <>
      {/* {value === 1 ? (
        <CallArchive />
      ) : value === 2 ? (
        <ManageExtension />
      ) : value === 3 ? (
        <LegacyCdr />
      ) : ( */}
      <div
        data-testid="callsInProgress"
        className=" h-full py-3.5 flex relative z-[1] overflow-hidden"
      >
        {/* sidebox */}
        <div className="h-[calc(100vh-126px)] blur-0  w-[calc(100vw-126px)] rounded-md bg-[#FFFFFF]">
          <FadeIn>
            {/* <Backdrop className="!z-[99999999999]" open={loader}>
              <Lottiefy
                loop={true}
                json={loaderLottie}
                height={100}
                width={100}
              />
            </Backdrop> */}
            <div className="pt-3">
              <TableTopBar
                showDropdownValues={tableTitles}
                setHideDropdownValues={handleTableTitle}
                title={"Active Calls"}
                // CSV={true}
                searchtext={searchtext}
                setSearchText={setSearchText}
              />
            </div>

            {searchtext !== "" ? (
              <Table
                tableTitles={tableTitles}
                tableData={eventsData?.filter((node: any) => {
                  const text = searchtext.toLowerCase();
                  return (
                    node?.direction?.toLowerCase()?.includes(text) ||
                    node?.extension?.toLowerCase()?.includes(text) ||
                    node?.status?.toLowerCase()?.includes(text) ||
                    node?.from_number?.toLowerCase()?.includes(text) ||
                    node?.to_number?.toLowerCase()?.includes(text) ||
                    node?.extension_name?.toLowerCase()?.includes(text)
                  );
                })}
                resultNotFound={resultNotFound}
                scrollHeight={"h-[calc(100vh-215px)] overflow-y-auto"}
                icons={icons}
              />
            ) : (
              <Table
                tableTitles={tableTitles}
                tableData={previewData}
                icons={icons}
                rowColor={"color"}
                actionHandler={actionHandler}
                scrollHeight={" h-[calc(100vh-215px)] overflow-y-auto"}
                resultNotFound={resultNotFound}
                resultNotFound_Message="No Active Calls!"
              />
            )}
          </FadeIn>
        </div>
      </div>
      {/* )} */}
    </>
  );
}

export default CallsInProgress;
